export default "__VITE_ASSET__cbbd7fc4__"